export default __webpack_public_path__ + "static/media/Themidas_logo.00ca7785.png";